var React = require('react');

function S04 (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_48493","data-name":"Rectangle 48493","width":"28","height":"28","fill":"none","key":0}),React.createElement("path",{"id":"Path_106564","data-name":"Path 106564","d":"M17.032,8.952c-.916-5.867-3.373-6.4-4.34-6.4s-3.411.535-4.327,6.4A8.218,8.218,0,0,0,4.75,15.774V23.4H6.4V15.774A6.59,6.59,0,0,1,8.11,11.345c-.038.611-.051,1.26-.051,1.947v4.327A2.485,2.485,0,0,0,10.541,20.1h4.315a2.485,2.485,0,0,0,2.482-2.482V13.292c0-.7-.025-1.336-.051-1.947a6.59,6.59,0,0,1,1.705,4.429V23.4h1.655V15.774a8.2,8.2,0,0,0-3.615-6.822Zm-1.349,8.667a.826.826,0,0,1-.827.827H10.541a.826.826,0,0,1-.827-.827V13.292C9.714,7,11.05,4.2,12.692,4.2s2.978,2.813,2.978,9.087v4.327Z","transform":"translate(1.295 0.695)","key":1})]);
}

S04.defaultProps = {"id":"s-05","width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = S04;

S04.default = S04;
